import React from 'react';
import moment from 'moment';
import Moment from 'react-moment';
import humanizeString from 'humanize-string';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { capitalizeFirstLetter } from '../../helpers';

const styles = theme => ({
  detentionTile: {
    marginBottom: 10,
    backgroundColor: '#fafafa',
  },
  detentionTileTypeNotattended: {
    backgroundColor: '#ffebee',
  },
  detentionTileTypeUpscaled: {
    backgroundColor: '#fbe9e7',
  },
  detentionTileTypePending: {
    backgroundColor: '#fff8e1',
  },
  detentionTileTypeAttended: {
    backgroundColor: '#e8f5e9',
  },
  detentionTileHeading: {
    color: '#394f5a',
    fontSize: 18,
    fontWeight: 500,
  },
  detentionTileSubHeading: {
    color: '#797979',
    fontSize: 12,
  },
  detentionTileArrowWrapper: {
    marginTop: 20,
    textAlign: 'right',
    color: '#797979',
  },
  detentionTileContent: {
    padding: 20,
    lineHeight: 1.5,
    color: '#394f5a',
  },
  detentionTileDetails: {
    borderTop: '1px solid #fff',
    padding: 20,
    color: '#797979',
    fontSize: 14,
  },
  detentionTileDetailsFooter: {
    padding: '20px 0 0',
    textTransform: 'uppercase',
    fontSize: 12,
  },
  detentionTileTitleWrapper: {
    flex: 5,
  },
  detentionTileChipWrapper: {
    flex: 1,
    flexShrink: 1,
    flexBasis: 140,
    width: 140,
    textAlign: 'right',
  },
  detentionChip: {
    marginLeft: 8,
    marginRight: 8,
    color: '#fff',
    height: 'auto',
    backgroundColor: '#9e9e9e',
  },
  detentionChipTypeNotattended: {
    backgroundColor: '#f44336',
  },
  detentionChipTypeUpscaled: {
    backgroundColor: '#f4511e',
  },
  detentionChipTypePending: {
    backgroundColor: '#ffb300',
  },
  detentionChipTypeAttended: {
    backgroundColor: '#39843b',
  },
});

class DetentionTile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: !isMobileApp,
    };

    this.onTileArrowClick = this.onTileArrowClick.bind(this);
  }

  onTileArrowClick() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render() {
    const {
      classes,
      t,
      detention,
      dateFormat,
    } = this.props;
    const {
      isOpen,
    } = this.state;

    const detentionStatus = detention.attended === 'yes'
      ? 'attended'
      : (detention.attended === 'pending'
        ? 'pending'
        : (detention.attended === 'upscaled'
          ? 'upscaled'
          : 'notattended'
        )
      );
    const chipText = detentionStatus === 'notattended'
      ? 'Not attended'
      : humanizeString(detentionStatus);
    const now = moment();
    const detentionDate = moment(detention.date);
    const isForceOpened = detentionDate.isSame(now, 'day')
      || detentionDate.isAfter(now, 'day');

    // Container class name
    const containerClassNameStyled = classes[`detentionTileType${capitalizeFirstLetter(detentionStatus)}`];
    const containerClassName = `${classes.detentionTile} ${containerClassNameStyled}`;

    // Chip class name
    const chipClassNameStyled = classes[`detentionChipType${capitalizeFirstLetter(detentionStatus)}`];
    const chipClassName = `${classes.detentionChip} ${chipClassNameStyled}`;

    return (
      <Paper
        elevation={1}
        className={`detention-tile ${containerClassName}`}
      >
        <div className={classes.detentionTileContent}>
          <Grid
            justify="space-between"
            container
            spacing={4}
            wrap="nowrap"
          >
            <Grid item className={classes.detentionTileTitleWrapper} zeroMinWidth>
              <div className={classes.detentionTileHeading}>
                {detention.detention_type && detention.detention_type.name}
              </div>
            </Grid>
            <Grid item className={classes.detentionTileChipWrapper}>
              <Chip
                label={chipText}
                className={chipClassName}
              />
            </Grid>
          </Grid>
          <Grid
            justify="space-between"
            container
            spacing={4}
          >
            <Grid item>
              <div className={classes.detentionTileSubHeading}>
                {detention.date && (
                  <div>
                    <span>{t('Date')}: </span>
                    <Moment format={dateFormat}>{detention.date}</Moment>
                  </div>
                )}
                {detention.time && (
                  <div>
                    <span>{t('Time')}: </span>
                    {detention.time}
                  </div>
                )}
              </div>
            </Grid>
            <Grid item>
              {isMobileApp && !isForceOpened && (
                <div
                  className={classes.detentionTileArrowWrapper}
                  onClick={this.onTileArrowClick}
                >
                  {!isOpen && <KeyboardArrowRight />}
                  {isOpen && <KeyboardArrowDown />}
                </div>
              )}
            </Grid>
          </Grid>
        </div>
        {(isOpen || isForceOpened) && (
          <div className={classes.detentionTileDetails}>
            {detention.location && (
              <div>
                <b>{t('Location')}: </b>
                {detention.location}
              </div>
            )}
            {detention.length > 0 && (
              <div>
                <b>{t('Duration')}: </b>
                {detention.length}
                <span> {t('min')}</span>
              </div>
            )}
            <div className={classes.detentionTileDetailsFooter}>
              {detention.lesson && (
                <span>
                  {detention.lesson.subject && (
                    <span>
                      {detention.lesson.subject.name}
                      <span> - </span>
                    </span>
                  )}
                  {detention.lesson.name}
                </span>
              )}
              {detention.lesson && detention.teacher && (<span> - </span>)}
              {detention.teacher && (
                <span>
                  <span>{detention.teacher.title} </span>
                  <span>{detention.teacher.first_name?.[0]} </span>
                  <span>{detention.teacher.last_name}</span>
                </span>
              )}
            </div>
          </div>
        )}
      </Paper>
    );
  }
}

export default withStyles(styles)(withTranslation()(DetentionTile));
